import * as React from "react";

import {useLatestRef} from "@khanacademy/wonder-blocks-core";

import {createEvent} from "./math-expressions-rendered-event.ts";
import {texAnalyticsService} from "./tex-analytics-service.ts";

/* eslint-disable react/no-unused-prop-types -- false positive: props is passed to useLatestRef */
interface Props {
    context: "ai-guide" | "content-library";
    renderer: "katex" | "mathjax2" | "mathjax3";
}
/* eslint-enable react/no-unused-prop-types -- false positive: props is passed to useLatestRef */

/**
 * Publish a CEDAR event on mount.
 *
 * This publishes a CEDAR event of type
 * ContentLibraryMathExpressionsRendered or AiGuideMathExpressionsRendered when
 * it mounts. The type of event published depends on the `context` prop.
 *
 * It might seem odd to use a component for this, but it was the least invasive
 * way of doing it based on how the legacy renderer (tex.jsx) used to work,
 * before it used an error boundary. We could revisit it but seems unnecessary
 * given that this works, and the associated code is in a deprecated state.
 */
export function AnalyticsEventEmitter(props: Props): React.ReactElement | null {
    const latestProps = useLatestRef(props);
    React.useEffect(() => {
        // We can't `useLocation` here, because this component gets used in e.g.
        // the exercise editor, where the necessary React context isn't present.
        // eslint-disable-next-line no-restricted-syntax -- see above comment
        const url = window.location.href;
        texAnalyticsService.postEvent(
            createEvent({
                ...latestProps.current,
                currentPageURL: url,
            }),
        );
    }, [latestProps]);
    return null;
}
